import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulse, Activity, Leaf, Shield, Droplet, Sparkles, CheckCircle2 } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function ProductExplanation() {
  const ingredients = [{
    icon: HeartPulse,
    text: 'Darm-Haut-Verbindung wissenschaftlich erklärt'
  }, {
    icon: Activity,
    text: 'Entzündungen im Darm = Entzündungen an der Haut'
  }, {
    icon: Leaf,
    text: 'Inulin & Topinambur: reduzieren Darmentzündungen'
  }, {
    icon: Shield,
    text: 'Mariendistel: entlastet Leber, die Giftstoffe filtert'
  }, {
    icon: Droplet,
    text: 'Leinsamen: Omega-3 wirkt entzündungshemmend'
  }, {
    icon: Sparkles,
    text: 'Gerstengraspulver: reich an Chlorophyll, reinigt von innen'
  }, {
    icon: CheckCircle2,
    text: '100% pflanzlich, keine künstlichen Zusätze'
  }];
  return <section className="w-full py-16 px-4 md:px-8 bg-sage/40 border-y border-forestGreen/10 my-12" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-114">
          <h2 className="font-handwritten text-4xl md:text-5xl text-forestGreen font-bold mb-4" data-id="element-115">
            Die Darm-Haut-Achse
          </h2>
          <p className="font-serif text-lg md:text-xl text-warmBrown/90 italic" data-id="element-116">
            Was dein Hund dir mit seinen Pfoten sagt
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-117">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex items-start gap-4 p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-sm ${index === ingredients.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-118">
              <div className="p-2 bg-forestGreen/10 rounded-lg text-forestGreen shrink-0" data-id="element-119">
                <item.icon size={24} data-id="element-120" />
              </div>
              <p className="font-serif text-gray-800 leading-relaxed pt-1" data-id="element-121">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-12 flex justify-center" data-id="element-122">
          <CtaButton label="Jetzt für meinen Hund bestellen" position="ingredients_cta" data-id="element-123" />
        </div>
      </div>
    </section>;
}